import { render, staticRenderFns } from "./QuestionsCreate.vue?vue&type=template&id=11b785a7&scoped=true"
import script from "./QuestionsCreate.vue?vue&type=script&lang=js"
export * from "./QuestionsCreate.vue?vue&type=script&lang=js"
import style0 from "./QuestionsCreate.vue?vue&type=style&index=0&id=11b785a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b785a7",
  null
  
)

export default component.exports